export const translations = {
    en: {
        nav: {
            home: 'Home',
            about: 'About',
            services: 'Services',
            team: 'Team',
            partners: 'Partners',
            journey: 'Journey',
            events: 'Events',
            portfolio: 'Portfolio',
            contact: 'Contact',
            getStarted: 'Get Started',
            toggleTheme: 'Toggle Theme',
            logoAlt: 'XyberClan — Professional Digital Agency Logo'
        },
        hero: {
            titlePrefix: 'Your Trusted',
            subtitle: 'Professional digital solutions for ambitious businesses and individuals.',
            fastDelivery: 'Fast Delivery',
            localExpertise: 'Local Expertise',
            fairPricing: 'Fair Pricing',
            provenResults: 'Proven Results',
            startProject: 'Start Your Project',
            exploreServices: 'Explore Services',
            typing: ['Web Dev', 'Design', 'CyberSec', 'Networks', 'Education', 'XyberClan'],
            titleHighlight: 'Digital',
            titleSuffix: 'Empires',
            titleLine1: 'Build',
            titleLine2a: 'to',
            titleLine2b: 'dominate',
            scroll: 'Scroll',
            aboutXyberclan: 'About XyberClan',
            transitionText: 'A premium digital agency focused on driving technological growth'
        },
        about: {
            title: 'About',
            subtitle: 'University-trained experts delivering enterprise solutions at startup speed.',
            mission: 'Mission',
            missionDesc: 'Empower businesses and individuals with comprehensive technology solutions that drive growth and innovation.',
            vision: 'Vision',
            visionDesc: 'To be Cameroon\'s leading tech partner, making cutting-edge technology accessible to everyone.',
            whyUs: 'Why XyberClan',
            whyUsDesc: 'Complete tech solutions under one roof, from development to design, hardware to education.',
            clanTitle: 'The Clan',
            clanDesc: 'Computer Science students from University of Yaoundé 1, active in Cameroon\'s tech community through workshops, hackathons, and training events.',
            roles: [
                'Full-Stack Web Developers (React, Node.js, Next.js)',
                'Mobile App Developers (React Native, Flutter)',
                'Graphic Designers & UI/UX Experts (Adobe Suite, Figma)',
                'Hardware & Network Technicians (Computer Repair, Network Setup)',
                'Cybersecurity Specialists (Penetration Testing, Security Audits)',
                'Tech Educators & Trainers (All Tech Domains)'
            ]
        },
        team: {
            title: 'Meet Our',
            subtitle: 'The passionate individuals behind XyberClan\'s success.',
            expertTeam: 'Our Expert Team',
            expertTeamDesc: 'Meet the talented professionals who make XyberClan exceptional. From web design to cybersecurity, our team brings diverse expertise to every project.',
            viewFullTeam: 'View Full Team',
            actionTitle: 'Our Team',
            actionSubtitle: 'in Action',
            actionDesc: 'Active members of Cameroon\'s tech community, regularly participating in workshops, hackathons, and collaborative coding sessions.',
            actions: [
                { title: 'Hands-On Coding Sessions', desc: 'Our team members actively engaged in collaborative coding and problem-solving sessions.' },
                { title: 'Python Workshop Participation', desc: 'Continuous learning and skill development through community workshops and training events.' },
                { title: 'Technical Collaboration', desc: 'Working together on real-world projects and technical challenges.' },
                { title: 'Tech Community Engagement', desc: 'Building connections and sharing knowledge within Cameroon\'s growing tech ecosystem.' }
            ]
        },
        services: {
            badge: 'Our Expertise',
            title: 'What We Do',
            subtitle: 'We don\'t just write code. We engineer digital assets that drive real business growth.',
            items: [
                { title: 'Web & App Development', desc: 'Scalable platforms built with React, Node, and Python. We engineer speed and reliability.', tags: ['React', 'Next.js', 'Mobile Native'] },
                { title: 'Cybersecurity & Audits', desc: 'Bank-grade security protocols. We break your system before hackers do.', tags: ['Pen Testing', 'SecOps', 'Compliance'] },
                { title: 'Product Design (UI/UX)', desc: 'Interfaces that feel inevitable. User-centric design systems that scale.', tags: ['Figma', 'Prototyping', 'Design Systems'] },
                { title: 'Digital Strategy', desc: 'Data-driven roadmaps for digital transformation and market dominance.', tags: ['Growth', 'Analytics', 'Consulting'] }
            ]
        },
        techStack: {
            title: 'Our',
            subtitle: 'We use the latest technologies to build scalable, secure, and high-performance solutions.',
            items: [
                { name: 'Frontend Development', desc: 'Modern JavaScript frameworks for responsive, interactive user interfaces.' },
                { name: 'Backend & Cloud', desc: 'Robust server-side technologies and cloud infrastructure.' },
                { name: 'Design & Prototyping', desc: 'Professional design software to create stunning visuals and user experiences.' },
                { name: 'Development & Collaboration', desc: 'Industry-standard tools for version control, project management, and team collaboration.' }
            ]
        },
        deliver: {
            title: 'What We',
            subtitle: 'Professional technology solutions that drive real results for businesses and individuals across Cameroon.',
            outcome: 'Outcome:',
            cta: 'Start Your Project Today',
            items: [
                { category: 'Web Development', title: 'Modern Business Websites', desc: 'Custom-built responsive websites with modern designs, fast performance, and seamless user experiences. From landing pages to full e-commerce platforms.', result: 'Professional online presence that converts visitors to customers' },
                { category: 'Graphic Design', title: 'Complete Brand Identity', desc: 'Professional logos, business flyers, marketing materials, and complete visual identity packages that make your brand stand out in the market.', result: 'Memorable branding that attracts and retains customers' },
                { category: 'IT Infrastructure', title: 'Enterprise Network Solutions', desc: 'Complete network setup and maintenance for businesses, including printer installation, hardware configuration, and ongoing technical support.', result: 'Reliable IT infrastructure that keeps your business running smoothly' }
            ]
        },
        insights: {
            title: 'Tech',
            subtitle: 'Stay updated with the latest trends, best practices, and insights across all technology domains.',
            learnMore: 'Learn More',
            exploreMore: 'Explore More Insights',
            items: [
                { category: 'Web Development', title: 'Modern Web Development with React and Next.js', desc: 'Discover how modern frameworks like React and Next.js are transforming web development with better performance and user experiences.' },
                { category: 'Design Trends', title: 'Creating Effective Brand Identity in 2024', desc: 'Learn the essential elements of memorable brand design, from logos to complete visual identity systems that resonate with your audience.' },
                { category: 'Cybersecurity', title: 'Essential Security Practices for Small Businesses', desc: 'Protect your business with fundamental cybersecurity practices including network security, data protection, and employee training.' }
            ]
        },
        contact: {
            title: 'Ready to',
            subtitle: 'Free consultation. Real solutions. Fast results.',
            items: [
                { title: 'Local Expertise', desc: 'Based in Yaoundé, providing personalized service across Cameroon.' },
                { title: 'Complete Solutions', desc: 'Development, design, hardware, and education under one roof.' },
                { title: 'Student Innovation', desc: 'Fresh perspectives and cutting-edge knowledge from INF experts.' }
            ],
            ctaTitle: 'Let\'s Build Something Amazing',
            ctaDesc: 'Ready to transform your ideas into reality? Get in touch today.',
            ctaButton: 'Contact Us Now'
        },
        partnership: {
            badge: 'Partnership',
            title: 'Hult Prize UY1 x XYBERCLAN',
            subtitle: 'Empowering Social Innovation',
            desc: 'A strategic alliance designed to bridge the gap between academic brilliance and professional engineering.',
            features: [
                'Boost of technological innovation within our teams.',
                'Technical accompaniment for high-impact projects.',
                'Synergy between tech expertise and social entrepreneurship.'
            ],
            slogan: 'Together, we push the limits of what is possible!'
        },
        partnersPage: {
            title: 'Our Strategic Partners',
            subtitle: 'Collaborating for a Greater Impact',
            hultStory: {
                title: 'The Hult Prize Collaboration',
                narrative: [
                    "At XyberClan, we believe that technology is the ultimate force multiplier for social good. That's why our partnership with the Hult Prize at University of Yaoundé 1 is so meaningful to us.",
                    "We aren't just technical consultants; we are innovation partners. We provide the 'digital muscles' and technical mentorship to the brilliant student teams competing to solve the world's most pressing challenges.",
                    "Through this collaboration, we help translate ambitious social entrepreneurship ideas into scalable, production-ready prototypes, ensuring that the next generation of Cameroonian leaders has the technical foundation they need to succeed."
                ],
                stats: [
                    { label: 'Technical Mentorship', value: '100%' },
                    { label: 'Innovation Boost', value: '24/7' },
                    { label: 'Social Impact', value: 'Global' }
                ]
            },
            ctaPartner: 'Become our partner or collaborator',
            ctaSponsor: 'Become a sponsor',
            partnerTitle: 'Strategic Partnership',
            partnerSubtitle: "Let's build the future together.",
            sponsorTitle: 'Become a Sponsor',
            sponsorSubtitle: 'Support innovation and empower the next generation.',
            submit: 'Submit Request',
            partnerForm: {
                title: 'Strategic Partnership',
                subtitle: 'Let\'s build the future together.',
                steps: [
                    {
                        id: 'type',
                        question: 'What type of partnership are you looking for?',
                        options: ['Technology Partner', 'Educational/University', 'Business Growth', 'Creative Collaboration', 'Other']
                    },
                    {
                        id: 'orgName',
                        question: 'What is the name of your organization?',
                        placeholder: 'Organization or Company name'
                    },
                    {
                        id: 'goal',
                        question: 'What is the primary goal of this collaboration?',
                        placeholder: 'Describe your vision for this partnership...'
                    },
                    {
                        id: 'timeline',
                        question: 'When would you like to start this collaboration?',
                        options: ['Immediate', 'Next Month', 'Within 3 Months', 'Flexible']
                    },
                    {
                        id: 'contact',
                        question: 'Who should we contact to discuss further?',
                        fields: ['Full Name', 'Phone Number', 'Email Address']
                    }
                ]
            },
            sponsorForm: {
                title: 'Become a Sponsor',
                subtitle: 'Support innovation and empower the next generation.',
                steps: [
                    {
                        id: 'type',
                        question: 'Who is sponsoring?',
                        options: ['Individual', 'Company/Enterprise', 'NGO/Organization', 'Public Institution', 'Other']
                    },
                    {
                        id: 'companyName',
                        question: 'Sponsor identity',
                        placeholder: 'Your name or organization name'
                    },
                    {
                        id: 'contribution',
                        question: 'What do you want to bring to us?',
                        options: ['Financial Support', 'Hardware/Equipment', 'Mentorship & Coaching', 'Venue/Space Hosting', 'Visibility & Media', 'Other']
                    },
                    {
                        id: 'motivation',
                        question: 'Why support XyberClan activities?',
                        placeholder: 'Tell us a bit about your motivation...'
                    },
                    {
                        id: 'contact',
                        question: 'Contact details for sponsorship',
                        fields: ['Full Name', 'Phone Number', 'Email Address']
                    }
                ]
            }
        },
        eventsPage: {
            title: 'Our Events & Blog',
            subtitle: 'Discover the events we participated in, our latest news, and community highlights.',
            badge: 'Latest Updates',
            readMore: 'Read More',
            articles: [
                {
                    id: 12,
                    type: 'Webinar',
                    date: 'July 10, 2026',
                    title: 'Our Very First Webinar — A Resounding Success!',
                    description: "On July 10, 2026, XyberClan proudly organised our very first webinar. It was an incredible success! The session explored the theme 'How I Started in Tech and Entrepreneurship' and featured inspiring speakers: Vanessa Manessong, Jerry Davis, Cabrel Donfang, and Brandon Kamga. Their passion and insights made it a truly unforgettable experience. We are grateful to everyone who joined and made this milestone so special.",
                    image: '/images/events/webinair.jpeg',
                    objectPosition: 'center 30%'
                },
                {
                    id: 11,
                    type: 'Hackathon',
                    date: 'June 2026',
                    title: 'PawaPay Builders Cameroon — 1st Edition',
                    description: 'We proudly participated in the PawaPay Builders Cameroon 1st Edition, organised by Mountain Hub and PawaPay. A remarkable fintech builder event that brought together Cameroon\'s brightest tech talent. One of our members secured 3rd place, demonstrating XyberClan\'s ability to innovate in the rapidly growing African fintech ecosystem.',
                    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center 30%'
                },
                {
                    id: 7,
                    type: 'Hackathon',
                    date: 'Recent',
                    title: 'Tech Hackathon Against GBV',
                    description: 'We participated in the Tech Hackathon Against Gender-Based Violence (GBV) and proudly secured 3rd place! This event allowed our team to leverage technology for social impact and develop innovative solutions.',
                    image: '/images/events/tech-hackathon-gbv.png',
                    objectPosition: 'center 20%'
                },
                {
                    id: 6,
                    type: 'Training',
                    date: 'Recent',
                    title: 'MTN Skill Academy Participation',
                    description: 'We participated in the MTN Skill Academy program, joining forces with other bright minds to develop our tech skills and enhance digital capabilities. Our team successfully completed the program, earning certifications and gaining valuable insights.',
                    image: '/images/events/mtn-skill-academy.png'
                },
                {
                    id: 5,
                    type: 'Conference',
                    date: 'Recent',
                    title: 'GDG Yaoundé - DevFest 2024',
                    description: 'Celebrating the Google DevFest with the GDG Yaoundé community. A day of learning, networking, and exploring the latest Google technologies and developer tools.',
                    images: ['/images/events/gdg-yaounde-1.png', '/images/events/gdg-yaounde-2.png'],
                    image: '/images/events/gdg-yaounde-2.png'
                },
                {
                    id: 4,
                    type: 'Community',
                    date: 'Recent',
                    title: 'Women Techmakers Meetup',
                    description: 'Participating in the Women Techmakers (WTM) meetup in Yaoundé, supporting diversity and inclusion in the tech ecosystem while learning from inspiring female tech leaders.',
                    image: '/images/events/wtm-yaounde-clean.png'
                },
                {
                    id: 10,
                    type: 'Hackathon',
                    date: 'Previous',
                    title: 'ICT4D Hackathon Observation',
                    description: 'Our team attended the ICT4D Hackathon as spectators, gaining valuable insights into how information and communication technologies are being leveraged for development. It was an inspiring experience to witness innovative digital solutions being designed to solve sustainable development challenges.',
                    image: '/images/events/ict4d-hackathon.png'
                },
                {
                    id: 3,
                    type: 'Networking',
                    date: 'Previous',
                    title: 'Meeting with Mr. Paul Arsène Biboum Billick',
                    description: 'An inspiring meeting with Mr. Paul Arsène Biboum Billick, a System Network and Security Administrator, and Cybersecurity Instructor. He shared professional insights and the reality of the cybersecurity landscape.',
                    image: '/images/events/paul-arsene.png',
                    url: 'https://www.linkedin.com/in/paul-ars%C3%A8ne-biboum-billick-86810132/'
                },
                {
                    id: 2,
                    type: 'Conference',
                    date: 'Previous',
                    title: 'Salon of Cybersecurity',
                    description: 'Attending the Cybersecurity Salon allowed us to stay at the forefront of digital protection, engaging with experts on ethical hacking and network security.',
                    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=2070&auto=format&fit=crop'
                },
                {
                    id: 1,
                    type: 'Summit',
                    date: 'Previous',
                    title: 'Cameroon Tech Summit',
                    description: 'Contributing to the digital transformation narrative at the Cameroon Tech Summit, connecting with innovators shaping the nation\'s technology future.',
                    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR245v1ulJ2PkSGG0kW--lYlyZ2hfnFYnhIpw&s'
                },
                {
                    id: 9,
                    type: 'Partnership',
                    date: 'Feb 2026',
                    title: 'Strategic Alliance: Official Technical Sponsors of Hult Prize UY1',
                    description: 'XyberClan is proud to announce its role as the official Technical Sponsor for the Hult Prize at the University of Yaoundé 1. We are providing mentorship, technical infrastructure, and digital muscle to help student entrepreneurs turn their social impact ideas into reality.',
                    image: '/images/events/hult-prize-sponsor.jpeg'
                },
                {
                    id: 8,
                    type: 'Press',
                    date: 'Feb 25, 2026',
                    title: 'XyberClan in the Spotlight: Featured in Journal l\'Etudiant',
                    description: 'We appeared in the Wednesday, February 25 edition of the Journal l\'Etudiant newspaper. The article highlights our leadership in cybersecurity as a "Guarantor of Digital Security" and our contribution to securing Cameroon\'s digital ecosystem.',
                    image: '/images/events/journal-etudiant.jpeg',
                    objectPosition: 'center 30%'
                }
            ]
        },
        journey: {
            title: 'Our Journey',
            subtitle: 'From a spark of passion to a force of innovation — every milestone has shaped who we are.',
            heroTag: 'The Story So Far',
            ctaTitle: 'The Next Chapter Starts With You',
            ctaDesc: 'Every great story needs the next bold move. Let us write it together.',
            events: [
                {
                    date: 'September 2023',
                    tag: 'Genesis',
                    title: 'The Spark That Started It All',
                    description: 'A group of passionate Computer Science students at the University of Yaoundé 1 came together with a shared vision: make cutting-edge technology accessible to everyone. XyberClan was born in a small campus room, fueled by ambition and late-night coding sessions.',
                    image: '/images/journey/genesis.jpeg',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'November 2023',
                    tag: 'Success',
                    title: 'Our First Professional Success',
                    description: 'We delivered our first enterprise-grade website, proving that university students could deliver professional solutions. This marked our official entrance into the digital market.',
                    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'March 2024',
                    tag: 'Alliance',
                    title: 'Strategic Partnership with Hult Prize UY1',
                    description: 'We became the technical muscle for social innovators. This partnership bridged the gap between academic brilliance and professional engineering.',
                    image: '/images/journey/hult-prize.jpg',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'August 2024',
                    tag: 'Security',
                    title: 'Cybersecurity Arm Goes Live',
                    description: 'Recognizing the critical need for digital protection, we officially launched our cybersecurity division, offering specialized audits and pentesting services.',
                    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center center'
                },
                {
                    date: 'November 2024',
                    tag: 'Community',
                    title: 'Deepening Community Roots at DevFest',
                    description: 'Our team actively participated in GDG Yaoundé DevFest 2024, engaging with the wider tech ecosystem and sharing insights on emerging Google technologies.',
                    image: '/images/journey/gdg.png',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'December 2024',
                    tag: 'Award',
                    title: '3rd Place at Tech Hackathon Against GBV',
                    description: 'We applied our skills for social impact, securing 3rd place in a national hackathon by developing innovative tech solutions against Gender-Based Violence.',
                    image: '/images/journey/hackathon.png',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'January 2025',
                    tag: 'Mentorship',
                    title: 'High-Level Professional Guidance',
                    description: 'We had the honor of meeting with Mr. Paul Arsène Biboum Billick, gaining invaluable professional insights into system security and network administration.',
                    image: '/images/journey/mentorship.png',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'January 2025',
                    tag: 'Observation',
                    title: 'ICT4D Hackathon Insights',
                    description: 'Our team attended the ICT4D Hackathon as spectators, witnessing how digital innovation is being applied to solve global development challenges.',
                    image: '/images/journey/ict4d-hackathon.png',
                    objectPosition: 'center 50%'
                },
                {
                    date: 'February 2025',
                    tag: 'Global',
                    title: 'Expanding Our Global Footprint',
                    description: 'From Cameroon to the world. XyberClan officially expanded its services to clients across Europe, North America, and other African nations.',
                    image: 'https://images.unsplash.com/photo-1529400971008-f566de0e6dfc?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center 40%'
                },
                {
                    date: 'February 2026',
                    tag: 'Media',
                    title: 'Featured in Journal l\'Etudiant',
                    description: 'Our vision for digital security was spotlighted in a major national publication, cementing our reputation as a trusted protector of the digital ecosystem.',
                    image: '/images/journey/media.jpeg',
                    objectPosition: 'center 30%'
                },
                {
                    date: 'July 10, 2026',
                    tag: 'Webinar',
                    title: 'Our Very First Webinar — A Resounding Success!',
                    description: "XyberClan proudly organised our very first webinar exploring the theme 'How I Started in Tech and Entrepreneurship'. Featuring Vanessa Manessong, Jerry Davis, Cabrel Donfang, and Brandon Kamga, the session was an incredible success and a milestone moment for our community.",
                    image: '/images/events/webinair.jpeg',
                    objectPosition: 'center 30%'
                }
            ]
        },
        teamPage: {
            title: 'Meet Our',
            titleBold: 'Specialists',
            subtitle: 'A premium collective of engineers, designers, and strategists working together to build exceptional technologies.',
            teamLabel: 'XyberClan Team',
            metaRole: 'Role',
            metaGeography: 'Geography',
            metaIndustry: 'Industry',
            metaExpertise: 'Key Expertise',
            visitPortfolio: 'Visit Portfolio',
            clickForMore: 'Click for more',
            members: {
                '1': {
                    name: 'Cedrik Darel Yepmo',
                    role: 'Co-Founder, CEO & Cybersecurity Analyst',
                    geography: 'Cameroon',
                    industry: 'Cybersecurity & AI Engineering',
                    expertise: 'Fullstack AI Web Development, Data Annotation, Cybersecurity Analysis',
                    description: "Founder and lead technologist of XyberClan. Cedrik architects and ships AI-powered fullstack web products while conducting cybersecurity analysis and maintaining high-quality data annotation pipelines — uniting executive vision with hands-on engineering."
                },
                '2': {
                    name: 'AKANA SIGNING JOSIAS AARON',
                    role: 'Co-Founder & CTO / AI Security Architect',
                    geography: 'Cameroon',
                    industry: 'Cybersecurity & Engineering',
                    expertise: 'Red Teaming, LLM Architect, Mobile Dev (Flutter)',
                    description: 'Chief Technology Officer and elite Red Teamer at XyberClan. Josias designs AI security architectures, leads offensive security engagements, and engineers cross-platform mobile applications (Flutter) — ensuring every system XyberClan delivers is robust, intelligent, and breach-resilient.'
                },
                '4': {
                    name: 'Ange Demanou',
                    role: 'UI/UX Lead Designer & Event Organiser',
                    geography: 'Cameroon',
                    industry: 'UI/UX Design & Data Analytics',
                    expertise: 'UI/UX Design, Web Development, Data Analysis',
                    description: 'UI/UX designer, web developer, and data professional at XyberClan. Ange designs intuitive user experiences, builds web interfaces, conducts data and junior business analysis, and manages social media strategy with a data-driven approach — all while actively advancing her expertise in machine learning research.'
                },
                '5': {
                    name: 'ONANA GREGOIRE LEGRAND',
                    role: 'Co-Founder, COO, IT & Cybersecurity Engineer',
                    geography: 'Cameroon',
                    industry: 'Business Intelligence',
                    expertise: 'Business Strategy, IT Engineering, Cybersecurity',
                    description: "Co-Founder and operational backbone of XyberClan. Onana drives high-level business strategy, manages IT infrastructure, and applies cybersecurity engineering to protect systems and data — combining Python-driven data analysis with operational leadership to scale every project to a globally competitive standard."
                },
                '6': {
                    name: 'William Chandler',
                    role: 'Visual Content & Canva Designer',
                    geography: 'Cameroon',
                    industry: 'Branding & Design',
                    expertise: 'Canva Pro Design, Visual Storytelling, Social Media Branding',
                    description: 'Visual content specialist and brand designer at XyberClan. William produces high-impact graphics and branded assets that communicate complex ideas clearly — maintaining a consistent, premium visual identity across all platforms and campaigns.'
                },
                '7': {
                    name: 'Theresa Tcheme',
                    role: 'Event Organiser & Media Manager',
                    geography: 'Cameroon',
                    industry: 'Communications & Media',
                    expertise: 'Entrepreneurship, UI/UX Design, Community Leadership',
                    description: '2nd-year Computer Science student at Université de Yaoundé I. Co-Founder & CEO of Greenfarmers. GDG Yaoundé Volunteer and Organiser of the Hult Prize OnCampus programme at the University of Yaoundé I — driving entrepreneurship, sustainability, and technology on campus.'
                },
                '8': {
                    name: 'ADJIA MVOA NDJI GABRIEL MONFILS',
                    role: 'Fullstack Dev & Systems Engineer',
                    geography: 'Cameroon',
                    industry: 'Software Engineering & Cybersecurity',
                    expertise: 'Fullstack Development, C & Assembly, Linux Sysadmin',
                    description: 'Computer science student at Université de Yaoundé I and a multidisciplinary engineer at XyberClan. Gabriel designs and builds fullstack web applications, writes low-level code in C and Assembly, administers Linux systems, develops games with Godot, conducts offensive and defensive cybersecurity operations, architects networks, orchestrates AI workflows via n8n, and applies financial market analysis — combining academic rigour with real-world engineering delivery.'
                },
                '9': {
                    name: 'Lembou Pharel',
                    role: 'Cybersecurity, DevOps & AI Systems Engineer',
                    geography: 'Cameroon',
                    industry: 'Cybersecurity & AI',
                    expertise: 'Penetration Testing, DevOps & CI/CD, Systems Engineering',
                    description: 'Cybersecurity engineer, DevOps practitioner, and systems architect at XyberClan. Lembou conducts penetration testing, automates and manages CI/CD infrastructure, builds secure web and mobile applications (Flutter), and applies AI to harden systems — delivering solutions that are intelligent, resilient, and production-ready.'
                },
                '10': {
                    name: 'Wandji Tchaleu Yann Félix',
                    role: 'Network Engineer, UI/UX Designer & Python Dev',
                    geography: 'Cameroon',
                    industry: 'Networks & Development',
                    expertise: 'Réseau & CCNA, Python Development, Graphic Design',
                    description: 'Network engineer and Python developer at XyberClan. CCNA-certified, Yann Félix designs and maintains robust network infrastructures, develops automation and data tooling in Python, and contributes graphic design expertise — bridging technical depth with clear visual communication.'
                }
            }
        },
        speakersPage: {
            metaTitle: 'Our Speakers | XyberClan Webinar Experts',
            metaDesc: 'Meet our lineup of expert speakers delivering insights on cybersecurity, AI, fullstack development, and digital innovation.',
            label: 'XyberClan Speakers',
            title: 'Our',
            titleBold: 'Speakers.',
            subtitle: 'Industry experts and thought leaders sharing actionable insights on cybersecurity, AI, development, and digital transformation.',
            connect: 'Connect with',
            speakers: {
                '1': {
                    name: 'Vanessa Manessong',
                    role: 'Investigative Data Analyst & OSINT Specialist',
                    description: 'Analyste de données spécialisée dans l\'analyse des écosystèmes informationnels, la désinformation en ligne et les enquêtes OSINT. Fondatrice de Gehmit, une organisation engagée dans l\'orientation et la formation des jeunes aux métiers du numérique. Passionnée par la data, l\'IA et l\'impact social des technologies.'
                },
                '2': {
                    name: 'Cabrel Donfang',
                    role: 'Serial Event Organiser & Tech Evangelist',
                    description: 'Organisateur d\'événements en série, fournisseur de solutions et évangéliste technologique. Passionné par la construction de communautés, la connexion des innovateurs et l\'adoption de la technologie à travers l\'Afrique.'
                },
                '3': {
                    name: 'Tamkwa Kamga Brandon',
                    role: 'Fullstack AI Developer & DevOps',
                    description: 'Fondateur et Mentor chez LesCrack. Développeur Fullstack AI et DevOps chez Gehmit. Passionné par la création de solutions alimentées par l\'IA évolutives et le mentorat de la prochaine génération de développeurs.'
                },
                '4': {
                    name: 'Ndjana Mengue Jerry',
                    role: 'Community Builder & Tech Leader',
                    description: 'Co-Fondateur & COO chez Hinkaku, Organisateur GDG Yaoundé, Leader AWS Student Builder Group. Dévoué à la construction de communautés tech florissantes et à l\'autonomisation des étudiants en cloud computing et leadership.'
                },
                '5': {
                    name: 'Theresa Tcheme',
                    role: 'Event Organiser & Mediator',
                    description: '2nd-year Computer Science student at Université de Yaoundé I. Co-Founder & CEO of Greenfarmers. GDG Yaoundé Volunteer and Organiser of the Hult Prize OnCampus programme at the University of Yaoundé I.'
                }
            }
        },
        portfolioPage: {
            title: 'Our Portfolio',
            subtitle: 'A showcase of projects we have built, designed, and delivered with passion.',
            filterLabel: 'Filter by',
            ctaBadge: 'Start a project',
            ctaHeading: 'Ready to build something exceptional?',
            ctaLink: 'Get in touch ↗',
            badge: 'Our Work',
            ctaTitle: 'Have a Project in Mind?',
            ctaDesc: 'Let us bring your vision to life. Start your project today.',
            ctaButton: 'Start Your Project',
            viewAll: 'View All Projects',
            visitSite: 'Visit the site',
            categories: {
                all: 'All',
                web: 'Web Development',
                mobile: 'Mobile Apps',
                design: 'Design & UI/UX',
                security: 'Cybersecurity'
            }
        },
        footer: {
            tagline: 'Building Digital Dreams in Yaoundé',
            columns: {
                nav: {
                    title: 'NAVIGATION',
                    items: [
                        { label: 'About Us', url: '/#about' },
                        { label: 'Services', url: '/#services' },
                        { label: 'Our Team', url: '/team' },
                        { label: 'Our Partners', url: '/partners' },
                        { label: 'Our Journey', url: '/journey' },
                        { label: 'Events & Blog', url: '/events' },
                        { label: 'Portfolio', url: '/portfolio' }
                    ]
                },
                expertise: {
                    title: 'EXPERTISE',
                    items: [
                        { label: 'Cybersecurity', url: '/#services' },
                        { label: 'Software Dev', url: '/#services' },
                        { label: 'Hardware Solutions', url: '/#services' },
                        { label: 'Digital Strategy', url: '/#services' }
                    ]
                },
                support: {
                    title: 'SUPPORT',
                    items: [
                        { label: 'Privacy Policy', url: '/privacy' },
                        { label: 'Terms of Service', url: '/terms' },
                        { label: 'Contact Us', url: '/#contact' }
                    ]
                }
            },
            cta: {
                title: 'Ready to start a project?',
                subtitle: "Let's build something exceptional together.",
                emailLabel: 'EMAIL US',
                email: 'xyberclandev@gmail.com',
                phoneLabel: 'CALL US',
                phone: '+237 6 54 26 94 88 / +237 6 96 81 43 91'
            },
            copyright: 'XYBERCLAN — ENGINEERED IN CAMEROON.',
            bottomLinks: {
                privacy: 'PRIVACY',
                terms: 'TERMS'
            },
            madeWith: 'Made with',
            madeBy: 'by XyberClan'
        },
        form: {
            step: 'Step',
            of: 'of',
            backToHome: 'Back to Home',
            backToEdit: 'Back to Edit',
            next: 'Next',
            previous: 'Previous',
            submit: 'Submit Request',
            summaryTitle: 'Perfect! Here\'s Your Summary',
            summaryDesc: 'Review your information and choose how to send it to us',
            sendWhatsApp: 'Send via WhatsApp',
            sendEmail: 'Send via Email',
            chooseSend: 'Choose how to send your project details:',
            projectType: 'Project Type',
            projectName: 'Project Name',
            description: 'Description',
            timeline: 'Timeline',
            budget: 'Budget',
            contactInfo: 'Contact Information',
            name: 'Name:',
            phone: 'Phone:',
            email: 'Email:',
            questions: {
                projectType: '🤔 What type of project do you need?',
                projectName: '🤩 What\'s your project or business name?',
                description: '😃 Tell us about your project',
                timeline: '🧐 What\'s your timeline?',
                budget: '🤑 What\'s your budget range?',
                contact: '👋 How can we contact you?'
            },
            placeholders: {
                projectName: 'e.g., My Awesome Startup',
                description: 'Describe what you need, your goals, and any specific requirements...',
                contactName: 'John Doe',
                contactPhone: '+237 6XX XX XX XX',
                contactEmail: 'john@example.com'
            },
            options: {
                web: 'Web Development',
                mobile: 'Mobile App',
                design: 'Graphic Design',
                cybersec: 'Cybersecurity',
                hardware: 'Hardware/Network',
                training: 'Tech Training',
                asap: 'ASAP',
                weeks: '1-2 Weeks',
                month: '1 Month',
                months: '2-3 Months',
                flexible: 'Flexible',
                under100k: 'Under 100k XAF',
                range1: '100k - 500k XAF',
                range2: '500k - 1M XAF',
                over1m: '1M+ XAF',
                notSure: 'Not Sure Yet'
            },
            contactLabels: {
                name: 'Your Name',
                phone: 'Phone Number',
                email: 'Email Address'
            },
            serviceQuestions: {
                web: [
                    {
                        id: 'webGoal',
                        question: '🌐 What is the primary goal of your website?',
                        options: ['E-commerce / Store', 'Business Profile', 'Portfolio / Personal', 'Custom Web App']
                    },
                    {
                        id: 'webPages',
                        question: '📄 Approximately how many pages do you need?',
                        options: ['1 Page (Landing Page)', '3-5 Pages', '6-10 Pages', '10+ Pages / Large Portal']
                    },
                    {
                        id: 'webFeatures',
                        multi: true,
                        question: '⚙️ Which features are essential?',
                        options: ['Contact Form', 'User Login/Auth', 'Online Payments', 'Blog / CMS', 'SEO Optimization', 'Multi-language Support', 'Newsletter / Email Marketing', 'Analytics Dashboard']
                    }
                ],
                mobile: [
                    {
                        id: 'mobilePlatform',
                        question: '📱 Which platform do you need?',
                        options: ['Android', 'iOS (iPhone)', 'Both / Cross-platform']
                    },
                    {
                        id: 'mobileType',
                        question: '💡 What type of app is it?',
                        options: ['E-commerce', 'Social Media', 'Productivity Tool', 'Management System']
                    }
                ],
                design: [
                    {
                        id: 'designType',
                        multi: true,
                        question: '🎨 What design services do you need?',
                        options: ['Logo & Branding', 'UI/UX Design', 'Social Media Graphics', 'Full Visual Identity', 'Business Cards', 'Flyer / Brochure Design', '3D Modeling', 'Video Editing']
                    },
                    {
                        id: 'designStyle',
                        multi: true,
                        question: '🖌️ What style do you prefer?',
                        options: ['Minimalist & Clean', 'Bold & Vibrant', 'Corporate & Professional', 'Artistic & Unique', 'Vintage / Retro', 'Futuristic / Tech', 'Luxury / Elegant']
                    }
                ],
                cybersec: [
                    {
                        id: 'secType',
                        multi: true,
                        question: '🛡️ What type of security service?',
                        options: ['Security Audit', 'Penetration Testing', 'Malware Removal', 'Continuous Protection', 'Vulnerability Assessment', 'Incident Response', 'Phishing Simulation', 'Data Encryption']
                    },
                    {
                        id: 'secTarget',
                        multi: true,
                        question: '🎯 What is the primary target?',
                        options: ['Website / Web App', 'Corporate Network', 'Mobile Application', 'Database / Cloud', 'Employee Workstations', 'IoT Devices']
                    }
                ],
                hardware: [
                    {
                        id: 'hwType',
                        question: '💻 What hardware service do you need?',
                        options: ['Computer Repair', 'Network Installation', 'Hardware Upgrade', 'IT Maintenance']
                    },
                    {
                        id: 'hwUrgency',
                        question: '⚡ How urgent is this request?',
                        options: ['Immediate / Emergency', 'Within 24-48 Hours', 'Routine / Scheduled']
                    }
                ],
                training: [
                    {
                        id: 'trainingSubject',
                        multi: true,
                        question: '🎓 What do you want to learn?',
                        options: ['Web Programming', 'Cybersecurity', 'Graphic Design', 'Office Suites / IT Basics', 'Mobile App Dev', 'Data Science', 'UI/UX Design', 'Digital Marketing']
                    },
                    {
                        id: 'trainingLevel',
                        question: '📊 What is your current level?',
                        options: ['Total Beginner', 'Intermediate', 'Advanced / Professional']
                    }
                ]
            }
        },
        seo: {
            title: "XyberClan — Digital Agency | Web, Design & Cybersecurity | Africa & Worldwide",
            description: "XyberClan — Your Trusted Digital Partner for Web, Design & Cybersecurity. Serving clients worldwide with professional solutions and competitive rates.",
            h1: "Your Trusted Digital Partner",
            h2_why: "Why choose XyberClan?",
            h2_services: "Our Services Available Worldwide",
            h2_standards: "A 24/7 Digital Partner",
            h3_web: "Professional Web Development",
            h3_design: "Graphic Design & UI/UX",
            h3_cyber: "Cybersecurity & Protection",
            h3_mobile: "Mobile Applications",
            paragraph: "XyberClan is your trusted digital partner based in Yaounde, Cameroon, serving clients in France, Belgium, Canada, Switzerland, Nigeria, Ghana, Senegal, the UK, USA and worldwide. We provide professional web development, mobile app creation, graphic design, UI/UX and cybersecurity services at competitive rates. Our team of experts combines technical excellence with creative innovation to deliver world-class digital solutions tailored to your unique needs.",
            h2_digital: "Digital",
            h2_excellence: "excellence."
        },
        pricing: {
            title: "Simple, Transparent Pricing",
            subtitle: "Choose a plan that fits your needs. All plans include our quality guarantee.",
            popularBadge: 'Most Popular',
            plans: [
                {
                    name: "Starter",
                    description: "Perfect for small projects and getting started",
                    price: "50K",
                    currency: "XAF",
                    features: [
                        "Simple landing page (1-3 pages)",
                        "Mobile responsive design",
                        "Contact form",
                        "Basic SEO setup",
                        "1 week delivery",
                        "7 days support after delivery"
                    ],
                    cta: "Start Small"
                },
                {
                    name: "Professional",
                    description: "Most popular for growing businesses",
                    price: "200K",
                    currency: "XAF",
                    features: [
                        "Full business website (5-10 pages)",
                        "Premium responsive design",
                        "Contact & booking forms",
                        "Photo gallery & portfolio",
                        "Social media integration",
                        "Advanced SEO optimization",
                        "2 weeks delivery",
                        "30 days support"
                    ],
                    cta: "Go Pro"
                },
                {
                    name: "Enterprise",
                    description: "Custom solutions for large projects",
                    price: "500K+",
                    currency: "XAF",
                    features: [
                        "Full web application",
                        "E-commerce capabilities",
                        "User authentication system",
                        "Admin dashboard",
                        "Payment integration",
                        "Custom features",
                        "Dedicated team",
                        "Priority support & maintenance"
                    ],
                    cta: "Contact Us"
                }
            ],
            note: "All prices are starting points. Final quote depends on specific requirements."
        },
        stats: {
            badge: 'Impact',
            title: 'Numbers that tell the story.',
            subtitle: 'Real results, real clients, real growth.'
        },
        team_minimal: {
            badge: "The XyberClan",
            title: "Meet Our Expert Team",
            subtitle: "A collective of software engineers, designers, and strategists dedicated to delivering enterprise-grade quality.",
            items: [
                {
                    title: "Engineering Excellence",
                    desc: "Our developers aren't just coders; they're engineers. We build for performance, security, and longevity."
                },
                {
                    title: "Design-First Mindset",
                    desc: "We believe in interfaces that are intuitive and beautiful. Every pixel serves a purpose in our designs."
                },
                {
                    title: "Strategic Growth",
                    desc: "Helping startups and enterprises scale their digital footprint with data-backed strategies and tools."
                }
            ]
        },
        features: {
            badge: 'Services',
            title: 'What we build for you.',
            subtitle: 'Four core disciplines. One unified team. Infinite possibilities.',
            items: [
                { title: 'Web & App Development', description: 'Performant, scalable web applications built with modern frameworks. Clean code, clean architecture.', tag: 'Web & Apps' },
                { title: 'Cybersecurity', description: 'Enterprise-grade security audits, pen testing, and hardening. Your data, defended.', tag: 'Security' },
                { title: 'Mobile Development', description: 'Cross-platform mobile experiences that feel native on iOS and Android.', tag: 'Mobile' },
                { title: 'UI/UX Design', description: 'Interfaces that convert. Pixel-perfect, accessibility-first, and human-centered.', tag: 'Design' }
            ]
        },
        faq: {
            badge: "Got Questions?",
            title: "Frequently Asked Questions",
            subtitle: "Everything you need to know about our services",
            ctaText: "Still have questions? We're happy to help.",
            ctaButton: "Chat with us",
            items: [
                {
                    question: "How much does a website cost?",
                    answer: "Our websites start from 50,000 XAF for basic landing pages. Business websites with multiple pages, contact forms, and galleries typically range from 150,000 - 500,000 XAF. E-commerce sites and web applications are custom-quoted based on features needed."
                },
                {
                    question: "How long does it take to build a website?",
                    answer: "A simple landing page can be completed in 3-5 days. Standard business websites take 1-2 weeks. More complex projects like e-commerce stores or web applications typically take 3-6 weeks depending on features and revisions."
                },
                {
                    question: "Do you offer mobile app development?",
                    answer: "Yes! We build mobile apps for both Android and iOS using modern technologies like React Native and Flutter. This allows us to create one app that works on both platforms, saving you time and money."
                },
                {
                    question: "What payment methods do you accept?",
                    answer: "We accept Mobile Money (MTN, Orange), bank transfers, and cash payments. We typically require 50% upfront to start the project, with the remaining 50% due upon completion."
                },
                {
                    question: "Do you provide ongoing support?",
                    answer: "Absolutely! We offer maintenance packages starting from 15,000 XAF/month that include hosting, security updates, backups, and minor content changes. We're always here to help even after your project is complete."
                },
                {
                    question: "Can you help with branding and design?",
                    answer: "Yes, we offer complete branding services including logo design, business cards, social media graphics, flyers, and full brand identity packages. Our designers create modern, professional designs that make your business stand out."
                },
                {
                    question: "Do I need to provide content for my website?",
                    answer: "While we can work with content you provide, we also offer content writing services. We can help write compelling copy for your website and source professional stock images if needed."
                },
                {
                    question: "What if I'm not satisfied with the design?",
                    answer: "We work closely with you throughout the design process and include revision rounds in all our packages. We won't stop until you're 100% happy with the result. Your satisfaction is our priority."
                }
            ]
        },
        whoWeAre: {
            badge: 'Who We Are',
            title1: 'Digital',
            title2: 'excellence.',
            subtitle: 'University-trained engineers delivering enterprise-grade solutions at startup speed. Based in Cameroon, serving the world.',
            card1Title: 'Rapid Innovation',
            card1Desc: 'Concept to deployed product in days, not months. We engineer speed without cutting corners.',
            card2Title: 'Scalable Architecture',
            card2Desc: 'Systems built to handle millions of users from day one, designed for the long game.',
            card3Title: 'Revenue Enablement',
            card3Desc: 'Every line of code and pixel is intentional — built to convert, retain, and grow.'
        },
        exitPopup: {
            title: 'Wait! Before You Go...',
            subtitle: 'Get a special offer just for you',
            badge: 'Limited Time Offer',
            offerTitle: 'Get 10% OFF Your First Project!',
            offerBody: 'Start your project with us today and get an exclusive 10% discount. Just mention this offer when you contact us!',
            ctaButton: 'Claim Your Discount',
            dismiss: 'No thanks, maybe later'
        },
        get_started: {
            badge: 'Integrations',
            title: 'Get started in simple steps.',
            subtitle: "Whether you're a small business or a large enterprise, our process enhances productivity and simplifies your workflow.",
            labels: {
                design: 'Design',
                code: 'Code',
                comm: 'Comm',
                deploy: 'Deploy',
                contact: 'Contact',
                support: 'Support'
            }
        },
        newsletter: {
            badge: 'Newsletter',
            title: 'Stay in the loop.',
            subtitle: 'Get tech tips, updates, and exclusive offers delivered directly to your inbox.',
            note: 'No spam. Unsubscribe anytime.'
        },
        cta: {
            title: "Ready to",
            titleLine2: "get started?",
            subtitle: "No demos, no lengthy calls. Tell us what you need — we'll build it.",
            primaryButton: "Start your project",
            secondaryButton: "Or contact us →"
        },
        heroArc: {
            cards: [
                { title: 'XyberShield App' },
                { title: 'NB Dance' },
                { title: 'Vanguard' },
                { title: 'Marketplace' },
                { title: 'Creative' }
            ]
        },
        testimonials: {
            badge: 'Testimonials',
            title: 'What our clients say.',
            subtitle: 'Real words from real clients who\'ve shipped with us.',
            list: [
                { quote: 'Concept to launched product in record time. XyberClan delivered exactly what we needed.', author: 'Paul Smith', role: 'Software Tester', company: 'Monaco' },
                { quote: 'Their attention to UX detail is unmatched. Our conversion rate jumped 40% after the redesign.', author: 'Tim Williams', role: 'Business Owner', company: 'Proline' },
                { quote: 'The security audit they performed found critical vulnerabilities we didn\'t know existed. Outstanding work.', author: 'Katie Adams', role: 'Entrepreneur', company: 'Delaware' },
                { quote: 'From design to deploy in two weeks. Responsive, fast, and exactly on brand. Highly recommend.', author: 'Alex Schiller', role: 'Senior Engineer', company: 'Luminous' }
            ]
        },
        whatsapp: {
            tooltip: 'Chat with us! 👋',
            contacts: [
                { label: 'Contact 1', number: '+237 654 269 488' },
                { label: 'Contact 2', number: '+237 696 814 391' }
            ]
        },
        careerPopup: {
            heading: "We're Hiring!",
            badge: 'Community Manager Position',
            tag: 'Join the XyberClan Team',
            title: 'Shape Our Community',
            description: 'We\'re looking for a passionate Community Manager to grow and nurture our digital community. Help us connect, engage, and build meaningful relationships with our audience.',
            cta: 'Apply Now',
            dismiss: 'Not right now'
        },
        themeSuggestion: {
            title: 'Better in Dark Mode?',
            description: 'Switch for the full neon liquid experience.',
            dismiss: 'No Thanks',
            cta: 'Switch Now'
        }
    },
    fr: {
        nav: {
            home: 'Accueil',
            about: 'À propos',
            services: 'Services',
            team: 'Équipe',
            partners: 'Partenaires',
            journey: 'Parcours',
            events: 'Événements',
            portfolio: 'Portfolio',
            contact: 'Contact',
            getStarted: 'Commencer',
            toggleTheme: 'Changer de thème',
            logoAlt: 'XyberClan — Agence Digitale Professionnelle Logo'
        },
        hero: {
            titlePrefix: 'Votre Partenaire de Confiance',
            subtitle: 'Solutions numériques professionnelles pour entreprises et particuliers ambitieux.',
            fastDelivery: 'Livraison Rapide',
            localExpertise: 'Expertise Locale',
            fairPricing: 'Prix Justes',
            provenResults: 'Résultats Prouvés',
            startProject: 'Lancer Votre Projet',
            exploreServices: 'Explorer les Services',
            typing: ['Dév Web', 'Design', 'CyberSécu', 'Réseaux', 'Formation', 'XyberClan'],
            titleHighlight: 'Highlight',
            titleSuffix: 'Empires',
            titleLine1: 'Construire',
            titleLine2a: 'pour',
            titleLine2b: 'dominer',
            scroll: 'Défiler',
            aboutXyberclan: 'À propos de XyberClan',
            transitionText: 'Une agence numérique premium axée sur le développement technologique'
        },
        about: {
            title: 'À propos de',
            subtitle: 'Des experts universitaires livrant des solutions d\'entreprise à la vitesse d\'une startup.',
            mission: 'Mission',
            missionDesc: 'Autonomiser les entreprises et les particuliers avec des solutions technologiques complètes qui stimulent la croissance et l\'innovation.',
            vision: 'Vision',
            visionDesc: 'Être le partenaire technologique leader au Cameroun, rendant la technologie de pointe accessible à tous.',
            whyUs: 'Pourquoi XyberClan',
            whyUsDesc: 'Solutions technologiques complètes sous un même toit, du développement au design, du matériel à la formation.',
            clanTitle: 'Le Clan',
            clanDesc: 'Étudiants en informatique de l\'Université de Yaoundé 1, actifs dans la communauté tech camerounaise à travers des ateliers, hackathons et formations.',
            roles: [
                'Développeurs Web Full-Stack (React, Node.js, Next.js)',
                'Développeurs d\'Applications Mobiles (React Native, Flutter)',
                'Graphistes & Experts UI/UX (Suite Adobe, Figma)',
                'Techniciens Matériel & Réseau (Réparation, Installation Réseau)',
                'Spécialistes Cybersécurité (Tests d\'intrusion, Audits)',
                'Formateurs Tech (Tous Domaines Tech)'
            ]
        },
        team: {
            title: 'Rencontrez Notre',
            subtitle: 'Les individus passionnés derrière le succès de XyberClan.',
            expertTeam: 'Notre Équipe d\'Experts',
            expertTeamDesc: 'Rencontrez les professionnels talentueux qui rendent XyberClan exceptionnel. Du web design à la cybersécurité, notre équipe apporte une expertise diversifiée à chaque projet.',
            viewFullTeam: 'Voir Toute l\'Équipe',
            actionTitle: 'Notre Équipe',
            actionSubtitle: 'en Action',
            actionDesc: 'Membres actifs de la communauté tech camerounaise, participant régulièrement à des ateliers, hackathons et sessions de codage collaboratif.',
            actions: [
                { title: 'Sessions de Codage Pratique', desc: 'Nos membres activement engagés dans des sessions de codage collaboratif et de résolution de problèmes.' },
                { title: 'Participation aux Ateliers Python', desc: 'Apprentissage continu et développement des compétences à travers des ateliers communautaires.' },
                { title: 'Collaboration Technique', desc: 'Travailler ensemble sur des projets réels et des défis techniques.' },
                { title: 'Engagement Communautaire Tech', desc: 'Tisser des liens et partager des connaissances au sein de l\'écosystème tech camerounais grandissant.' }
            ]
        },
        services: {
            badge: 'Notre Expertise',
            title: 'Notre Savoir-Faire',
            subtitle: 'Nous ne faisons pas qu\'écrire du code. Nous concevons des actifs numériques qui génèrent une réelle croissance commerciale.',
            items: [
                { title: 'Développement Web & App', desc: 'Plateformes évolutives construites avec React, Node et Python. Nous concevons la rapidité et la fiabilité.', tags: ['React', 'Next.js', 'Natif Mobile'] },
                { title: 'Cybersécurité & Audits', desc: 'Protocoles de sécurité de niveau bancaire. Nous cassons votre système avant les pirates.', tags: ["Tests d'Intrusion", 'SecOps', 'Conformité'] },
                { title: 'Design Produit (UI/UX)', desc: 'Des interfaces qui semblent naturelles. Des systèmes de design centrés sur l\'utilisateur qui évoluent.', tags: ['Figma', 'Prototypage', 'Systèmes de Design'] },
                { title: 'Stratégie Digitale', desc: 'Feuilles de route basées sur les données pour la transformation numérique et la domination du marché.', tags: ['Croissance', 'Analytique', 'Conseil'] }
            ]
        },
        techStack: {
            title: 'Notre',
            subtitle: 'Nous utilisons les dernières technologies pour construire des solutions évolutives, sécurisées et performantes.',
            items: [
                { name: 'Développement Frontend', desc: 'Frameworks JavaScript modernes pour des interfaces utilisateur réactives et interactives.' },
                { name: 'Backend & Cloud', desc: 'Technologies côté serveur robustes et infrastructure cloud.' },
                { name: 'Design & Prototypage', desc: 'Logiciels de design professionnels pour créer des visuels et expériences utilisateur époustouflants.' },
                { name: 'Développement & Collaboration', desc: 'Outils standards de l\'industrie pour le contrôle de version, la gestion de projet et la collaboration.' }
            ]
        },
        deliver: {
            title: 'Ce Que Nous',
            subtitle: 'Des solutions technologiques professionnelles qui génèrent des résultats réels pour les entreprises et particuliers au Cameroun.',
            outcome: 'Résultat :',
            cta: 'Lancez Votre Projet Aujourd\'hui',
            items: [
                { category: 'Développement Web', title: 'Sites Web d\'Entreprise Modernes', desc: 'Sites web réactifs sur mesure avec des designs modernes, des performances rapides et une expérience utilisateur fluide.', result: 'Présence en ligne professionnelle qui convertit les visiteurs en clients' },
                { category: 'Design Graphique', title: 'Identité de Marque Complète', desc: 'Logos professionnels, flyers, supports marketing et packages d\'identité visuelle complets pour démarquer votre marque.', result: 'Image de marque mémorable qui attire et fidélise les clients' },
                { category: 'Infrastructure IT', title: 'Solutions Réseau d\'Entreprise', desc: 'Installation et maintenance réseau complètes pour entreprises, incluant imprimantes, configuration matériel et support technique.', result: 'Infrastructure IT fiable qui assure le bon fonctionnement de votre entreprise' }
            ]
        },
        insights: {
            title: 'Infos',
            subtitle: 'Restez informé des dernières tendances, meilleures pratiques et actualités dans tous les domaines technologiques.',
            learnMore: 'En Savoir Plus',
            exploreMore: 'Explorer Plus d\'Articles',
            items: [
                { category: 'Développement Web', title: 'Dév Web Moderne avec React et Next.js', desc: 'Découvrez comment les frameworks modernes comme React et Next.js transforment le développement web avec de meilleures performances.' },
                { category: 'Tendances Design', title: 'Créer une Identité de Marque Efficace en 2024', desc: 'Apprenez les éléments essentiels d\'un design de marque mémorable, des logos aux systèmes d\'identité visuelle complets.' },
                { category: 'Cybersécurité', title: 'Pratiques de Sécurité Essentielles pour PME', desc: 'Protégez votre entreprise avec des pratiques fondamentales de cybersécurité incluant la sécurité réseau et la protection des données.' }
            ]
        },
        contact: {
            title: 'Prêt à',
            subtitle: 'Consultation gratuite. Solutions réelles. Résultats rapides.',
            items: [
                { title: 'Expertise Locale', desc: 'Basé à Yaoundé, fournissant un service personnalisé à travers le Cameroun.' },
                { title: 'Solutions Complètes', desc: 'Développement, design, matériel et éducation sous un même toit.' },
                { title: 'Innovation Étudiante', desc: 'Perspectives fraîches et connaissances de pointe des experts INF.' }
            ],
            ctaTitle: 'Construisons Quelque Chose d\'Incroyable',
            ctaDesc: 'Prêt à transformer vos idées en réalité ? Contactez-nous aujourd\'hui.',
            ctaButton: 'Contactez-nous Maintenant'
        },
        partnership: {
            badge: 'Partenariat',
            title: 'Hult Prize UY1 x XYBERCLAN',
            subtitle: 'Autonomiser l\'Innovation Sociale',
            desc: 'Une alliance stratégique conçue pour combler le fossé entre l\'excellence académique et l\'ingénierie professionnelle.',
            features: [
                'Boost de l\'innovation technologique au sein de nos équipes.',
                'Accompagnement technique pour des projets à fort impact.',
                'Synergie entre expertise tech et entrepreneuriat social.',
            ],
            slogan: 'Ensemble, nous repoussons les limites du possible !'
        },
        partnersPage: {
            title: 'Nos Partenaires Stratégiques',
            subtitle: 'Collaborer pour un Impact Plus Grand',
            hultStory: {
                title: 'La Collaboration Hult Prize',
                narrative: [
                    "Chez XyberClan, nous croyons que la technologie est le multiplicateur de force ultime pour le bien social. C'est pourquoi notre partenariat avec le Hult Prize de l'Université de Yaoundé 1 est si important pour nous.",
                    "Nous ne sommes pas seulement des consultants techniques ; nous sommes des partenaires d'innovation. Nous fournissons les 'muscles numériques' et le mentorat technique aux brillantes équipes d'étudiants qui luttent pour résoudre les défis les plus pressants du monde.",
                    "Grâce à cette collaboration, nous aidons à traduire des idées ambitieuses d'entrepreneuriat social en prototypes évolutifs et prêts pour la production, garantissant que la prochaine génération de leaders camerounais dispose de la base technique nécessaire pour réussir."
                ],
                stats: [
                    { label: 'Mentorat Technique', value: '100%' },
                    { label: 'Boost d\'Innovation', value: '24/7' },
                    { label: 'Impact Social', value: 'Global' }
                ]
            },
            ctaPartner: 'Devenir notre partenaire ou collaborateur',
            ctaSponsor: 'Devenir un sponsor',
            partnerTitle: 'Partenariat Stratégique',
            partnerSubtitle: "Bâtissons l'avenir ensemble.",
            sponsorTitle: 'Devenir Sponsor',
            sponsorSubtitle: "Soutenez l'innovation et dynamisez la prochaine génération.",
            submit: 'Envoyer la Demande',
            partnerForm: {
                title: 'Partenariat Stratégique',
                subtitle: 'Bâtissons l\'avenir ensemble.',
                steps: [
                    {
                        id: 'type',
                        question: 'Quel type de partenariat recherchez-vous ?',
                        options: ['Partenaire Technologique', 'Éducatif / Université', 'Croissance d\'Affaires', 'Collaboration Créative', 'Autre']
                    },
                    {
                        id: 'orgName',
                        question: 'Quel est le nom de votre organisation ?',
                        placeholder: 'Nom de l\'organisation ou de l\'entreprise'
                    },
                    {
                        id: 'goal',
                        question: 'Quel est l\'objectif principal de cette collaboration ?',
                        placeholder: 'Décrivez votre vision pour ce partenariat...'
                    },
                    {
                        id: 'timeline',
                        question: 'Quand souhaiteriez-vous commencer cette collaboration ?',
                        options: ['Immédiat', 'Mois Prochain', 'Sous 3 Mois', 'Flexible']
                    },
                    {
                        id: 'contact',
                        question: 'Qui devrions-nous contacter pour en discuter ?',
                        fields: ['Nom Complet', 'Numéro de Téléphone', 'Adresse Email']
                    }
                ]
            },
            sponsorForm: {
                title: 'Devenir Sponsor',
                subtitle: 'Soutenez l\'innovation et dynamisez la prochaine génération.',
                steps: [
                    {
                        id: 'type',
                        question: 'Qui parraine ?',
                        options: ['Individu', 'Compagnie/Entreprise', 'ONG/Organisation', 'Institution Publique', 'Autre']
                    },
                    {
                        id: 'companyName',
                        question: 'Identité du sponsor',
                        placeholder: 'Votre nom ou nom de l\'organisation'
                    },
                    {
                        id: 'contribution',
                        question: 'Que voulez-vous nous apporter ?',
                        options: ['Soutien Financier', 'Matériel/Équipement', 'Mentorat & Coaching', 'Hébergement / Espace', 'Visibilité & Médias', 'Autre']
                    },
                    {
                        id: 'motivation',
                        question: 'Pourquoi soutenir les activités de XyberClan ?',
                        placeholder: 'Dites-nous en un peu plus sur votre motivation...'
                    },
                    {
                        id: 'contact',
                        question: 'Coordonnées pour le parrainage',
                        fields: ['Nom Complet', 'Numéro de Téléphone', 'Adresse Email']
                    }
                ]
            }
        },
        eventsPage: {
            title: 'Nos Événements & Blog',
            subtitle: 'Découvrez les événements auxquels nous avons participé, nos dernières actualités et nos moments forts.',
            badge: 'Dernières Mises à Jour',
            readMore: 'Lire la Suite',
            articles: [
                {
                    id: 12,
                    type: 'Webinaire',
                    date: '10 Juillet 2026',
                    title: 'Notre Tout Premier Webinaire — Un Vrai Succès !',
                    description: "Le 10 juillet 2026, XyberClan a fièrement organisé son tout premier webinaire. Ce fut un succès retentissant ! La session a exploré le thème 'Comment j'ai commencé dans la Tech et l'Entrepreneuriat' et a réuni des intervenants inspirants : Vanessa Manessong, Jerry Davis, Cabrel Donfang et Brandon Kamga. Leur passion et leurs idées ont rendu cette expérience vraiment inoubliable. Nous sommes reconnaissants envers tous ceux qui se sont joints à nous pour faire de cette étape un moment si spécial.",
                    image: '/images/events/webinair.jpeg',
                    objectPosition: 'center 30%'
                },
                {
                    id: 11,
                    type: 'Hackathon',
                    date: 'Juin 2026',
                    title: 'PawaPay Builders Cameroun — 1ère Édition',
                    description: 'Nous avons fièrement participé à la 1ère édition de PawaPay Builders Cameroun, organisée par Mountain Hub et PawaPay. Un événement fintech exceptionnel qui a réuni les meilleurs talents tech du Cameroun. L\'un de nos membres a décroché la 3ème place, démontrant la capacité d\'XyberClan à innover dans l\'écosystème fintech africain en pleine expansion.',
                    image: '/images/events/pawapay.jpg',
                    objectPosition: 'center 30%'
                },
                {
                    id: 7,
                    type: 'Hackathon',
                    date: 'Récent',
                    title: 'Hackathon Tech Contre les VBG',
                    description: 'Nous avons participé au Hackathon Tech Contre les Violences Basées sur le Genre (VBG) et avons fièrement décroché la 3ème place ! Cet événement nous a permis de mettre la technologie au service de l\'impact social et de développer des solutions innovantes.',
                    image: '/images/events/tech-hackathon-gbv.png',
                    objectPosition: 'center 20%'
                },
                {
                    id: 6,
                    type: 'Formation',
                    date: 'Récent',
                    title: 'Participation à la MTN Skill Academy',
                    description: 'Nous avons participé au programme MTN Skill Academy, unissant nos forces à d\'autres esprits brillants pour développer nos compétences technologiques. L\'équipe a terminé le programme avec succès, obtenant des certifications et de précieuses connaissances.',
                    image: '/images/events/mtn-skill-academy.png'
                },
                {
                    id: 5,
                    type: 'Conférence',
                    date: 'Récent',
                    title: 'GDG Yaoundé - DevFest 2024',
                    description: 'Célébration du Google DevFest avec la communauté GDG Yaoundé. Une journée d\'apprentissage, de réseautage et d\'exploration des dernières technologies Google.',
                    images: ['/images/events/gdg-yaounde-1.png', '/images/events/gdg-yaounde-2.png'],
                    image: '/images/events/gdg-yaounde-2.png'
                },
                {
                    id: 4,
                    type: 'Communauté',
                    date: 'Récent',
                    title: 'Meetup Women Techmakers',
                    description: 'Participation au meetup Women Techmakers (WTM) à Yaoundé, soutenant la diversité et l\'inclusion dans l\'écosystème tech tout en apprenant de leaders inspirantes.',
                    image: '/images/events/wtm-yaounde-clean.png'
                },
                {
                    id: 10,
                    type: 'Hackathon',
                    date: 'Précédent',
                    title: 'Observation au Hackathon ICT4D',
                    description: 'Notre équipe a assisté au Hackathon ICT4D en tant que spectateurs, acquérant des connaissances précieuses sur la manière dont les technologies de l\'information et de la communication sont utilisées pour le développement. Ce fut une expérience inspirante de voir des solutions numériques innovantes être conçues pour résoudre les défis du développement durable.',
                    image: '/images/events/ict4d-hackathon.png'
                },
                {
                    id: 3,
                    type: 'Réseautage',
                    date: 'Précédent',
                    title: 'Rencontre avec M. Paul Arsène Biboum Billick',
                    description: 'Une rencontre inspirante avec M. Paul Arsène Biboum Billick, Administrateur Réseau et Sécurité. Il a partagé des perspectives professionnelles et la réalité du paysage de la cybersécurité.',
                    image: '/images/events/paul-arsene.png',
                    url: 'https://www.linkedin.com/in/paul-ars%C3%A8ne-biboum-billick-86810132/'
                },
                {
                    id: 2,
                    type: 'Conférence',
                    date: 'Précédent',
                    title: 'Salon de la Cybersécurité',
                    description: 'La participation au Salon de la Cybersécurité nous a permis de rester à la pointe de la protection numérique, en échangeant avec des experts sur le hacking éthique.',
                    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=2070&auto=format&fit=crop'
                },
                {
                    id: 1,
                    type: 'Sommet',
                    date: 'Précédent',
                    title: 'Cameroon Tech Summit',
                    description: 'Contribution au récit de la transformation numérique au Cameroon Tech Summit, en contact avec les innovateurs qui façonnent l\'avenir technologique de la nation.',
                    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR245v1ulJ2PkSGG0kW--lYlyZ2hfnFYnhIpw&s'
                },
                {
                    id: 9,
                    type: 'Partenariat',
                    date: 'Fév 2026',
                    title: 'Alliance Stratégique : Sponsors Techniques Officiels du Hult Prize UY1',
                    description: 'XyberClan est fier d\'annoncer son rôle de Sponsor Technique officiel pour le Hult Prize à l\'Université de Yaoundé 1. Nous fournissons le mentorat, l\'infrastructure technique et la force digitale nécessaire pour aider les étudiants entrepreneurs à concrétiser leurs idées d\'impact social.',
                    image: '/images/events/hult-prize-sponsor.jpeg'
                },
                {
                    id: 8,
                    type: 'Presse',
                    date: '25 Fév 2026',
                    title: 'XyberClan à la Une : Publié dans le Journal l\'Etudiant',
                    description: 'Nous sommes parus dans l\'édition du mercredi 25 février du journal "Journal l\'Etudiant". L\'article souligne notre rôle de "Garant de la sécurité numérique" et notre engagement pour la cybersécurité au Cameroun.',
                    image: '/images/events/journal-etudiant.jpeg',
                    objectPosition: 'center 30%'
                }
            ]
        },
        journey: {
            title: 'Notre Parcours',
            subtitle: 'D\'une étincelle de passion à une force d\'innovation — chaque étape a façonné ce que nous sommes.',
            heroTag: 'L\'Histoire Jusqu\'ici',
            ctaTitle: 'Le Prochain Chapitre Commence Avec Vous',
            ctaDesc: 'Chaque grande histoire a besoin d\'un prochain coup audacieux. Écrivons-le ensemble.',
            events: [
                {
                    date: 'Septembre 2023',
                    tag: 'Genèse',
                    title: 'L\'Étincelle Qui a Tout Lancé',
                    description: 'Un groupe d\'étudiants passionnés en informatique de l\'Université de Yaoundé 1 s\'est réuni avec une vision commune : rendre la technologie de pointe accessible à tous. XyberClan est né dans une petite salle de campus, alimenté par l\'ambition.',
                    image: '/images/journey/genesis.jpeg',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'Novembre 2023',
                    tag: 'Succès',
                    title: 'Notre Premier Succès Professionnel',
                    description: 'Nous avons livré notre premier site web de niveau entreprise, prouvant que des étudiants pouvaient offrir des solutions professionnelles. Cela a marqué notre entrée officielle sur le marché.',
                    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'Mars 2024',
                    tag: 'Alliance',
                    title: 'Partenariat Stratégique avec Hult Prize UY1',
                    description: 'Nous sommes devenus le moteur technique des innovateurs sociaux. Ce partenariat a comblé le fossé entre l\'excellence académique et l\'ingénierie professionnelle.',
                    image: '/images/journey/hult-prize.jpg',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'Août 2024',
                    tag: 'Sécurité',
                    title: 'Lancement de la Division Cybersécurité',
                    description: 'Reconnaissant le besoin critique de protection numérique, nous avons officiellement lancé notre division cybersécurité, offrant des audits spécialisés et des services de pentesting.',
                    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center center'
                },
                {
                    date: 'Novembre 2024',
                    tag: 'Communauté',
                    title: 'Engagement au DevFest 2024',
                    description: 'Notre équipe a activement participé au GDG Yaoundé DevFest 2024, échangeant avec l\'écosystème tech et partageant ses connaissances sur les nouvelles technologies Google.',
                    image: '/images/journey/gdg.png',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'Décembre 2024',
                    tag: 'Prix',
                    title: '3ème Place au Hackathon Tech contre les VBG',
                    description: 'Nous avons mis nos compétences au service de l\'impact social, décrochant la 3ème place d\'un hackathon national en développant des solutions contre les Violences Basées sur le Genre.',
                    image: '/images/journey/hackathon.png',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'Janvier 2025',
                    tag: 'Mentorat',
                    title: 'Conseils Professionnels de Haut Niveau',
                    description: 'Nous avons eu l\'honneur de rencontrer M. Paul Arsène Biboum Billick, bénéficiant d\'une expertise inestimable en sécurité système et administration réseau.',
                    image: '/images/journey/mentorship.png',
                    objectPosition: 'center 20%'
                },
                {
                    date: 'Janvier 2025',
                    tag: 'Observation',
                    title: 'Perspectives du Hackathon ICT4D',
                    description: 'Notre équipe a assisté au Hackathon ICT4D en tant que spectateurs, observant comment l\'innovation numérique est appliquée pour résoudre les défis du développement mondial.',
                    image: '/images/events/ict4d-hackathon.png'
                },
                {
                    date: 'Février 2025',
                    tag: 'Global',
                    title: 'Expansion de Notre Empreinte Mondiale',
                    description: 'Du Cameroun vers le monde. XyberClan a officiellement étendu ses services à des clients à travers l\'Europe, l\'Amérique du Nord et d\'autres nations africaines.',
                    image: 'https://images.unsplash.com/photo-1529400971008-f566de0e6dfc?q=80&w=2070&auto=format&fit=crop',
                    objectPosition: 'center 40%'
                },
                {
                    date: 'Février 2026',
                    tag: 'Média',
                    title: 'À la Une du Journal l\'Etudiant',
                    description: 'Notre vision pour la sécurité numérique a été mise en lumière dans une publication nationale majeure, consolidant notre réputation de protecteur de l\'écosystème digital.',
                    image: '/images/journey/media.jpeg',
                    objectPosition: 'center 30%'
                },
                {

                    date: 'Juin 2026',
                    title: 'PawaPay Builders Cameroun — 1ère Édition',
                    description: 'Nous avons fièrement participé à la 1ère édition de PawaPay Builders Cameroun, organisée par Mountain Hub et PawaPay. Un événement fintech exceptionnel qui a réuni les meilleurs talents tech du Cameroun. L\'un de nos membres a décroché la 3ème place, démontrant la capacité d\'XyberClan à innover dans l\'écosystème fintech africain en pleine expansion.',
                    image: '/images/events/pawapay.jpg',
                    objectPosition: 'center 30%'
                },
                {
                    date: '10 Juillet 2026',
                    tag: 'Webinaire',
                    title: 'Notre Tout Premier Webinaire — Un Vrai Succès !',
                    description: "XyberClan a fièrement organisé son tout premier webinaire sur le thème 'Comment j'ai commencé dans la Tech et l'Entrepreneuriat'. Avec Vanessa Manessong, Jerry Davis, Cabrel Donfang et Brandon Kamga, la session a été un succès retentissant et un moment marquant pour notre communauté.",
                    image: '/images/events/webinair.jpeg',
                    objectPosition: 'center 30%'
                }
            ]
        },
        teamPage: {
            title: 'Rencontrez Nos',
            titleBold: 'Spécialistes',
            subtitle: 'Un collectif haut de gamme d\'ingénieurs, designers et stratèges travaillant ensemble pour bâtir des technologies exceptionnelles.',
            teamLabel: 'Équipe XyberClan',
            metaRole: 'Rôle',
            metaGeography: 'Localisation',
            metaIndustry: 'Secteur',
            metaExpertise: 'Expertises Clés',
            visitPortfolio: 'Voir le Portfolio',
            clickForMore: 'Cliquez pour en savoir plus',
            members: {
                '1': {
                    name: 'Cedrik Darel Yepmo',
                    role: 'Co-Fondateur, CEO & Analyste Cybersécurité',
                    geography: 'Cameroun',
                    industry: 'Cybersécurité & Ingénierie IA',
                    expertise: 'Développement Web Fullstack IA, Annotation de Données, Analyse Cybersécurité',
                    description: 'Fondateur et technologue principal de XyberClan. Cedrik conçoit et déploie des produits web fullstack alimentés par l\'IA tout en menant des analyses de cybersécurité et en maintenant des pipelines d\'annotation de données de haute qualité — unissant vision exécutive et ingénierie pratique.'
                },
                '2': {
                    name: 'AKANA SIGNING JOSIAS AARON',
                    role: 'Co-Fondateur & CTO / Architecte Sécurité IA',
                    geography: 'Cameroun',
                    industry: 'Cybersécurité & Ingénierie',
                    expertise: 'Red Teaming, Architecte LLM, Développement Mobile (Flutter)',
                    description: 'Directeur Technologique et Red Teamer d\'élite chez XyberClan. Josias conçoit des architectures de sécurité IA, mène des engagements offensifs de sécurité et développe des applications mobiles multiplateformes (Flutter) — garantissant que chaque système livré par XyberClan est robuste, intelligent et résistant aux brèches.'
                },
                '4': {
                    name: 'Ange Demanou',
                    role: 'Designer UI/UX Lead & Organisatrice d\'Événements',
                    geography: 'Cameroun',
                    industry: 'Design UI/UX & Analyse de Données',
                    expertise: 'Design UI/UX, Développement Web, Analyse de Données',
                    description: 'Designer UI/UX, développeuse web et professionnelle des données chez XyberClan. Ange conçoit des expériences utilisateur intuitives, construit des interfaces web, effectue des analyses de données et d\'analyse commerciale junior, et gère la stratégie des médias sociaux avec une approche basée sur les données — tout en avançant activement son expertise en recherche en apprentissage automatique.'
                },
                '5': {
                    name: 'ONANA GREGOIRE LEGRAND',
                    role: 'Co-Fondateur, COO, Ingénieur IT & Cybersécurité',
                    geography: 'Cameroun',
                    industry: 'Intelligence d\'Affaires',
                    expertise: 'Stratégie d\'Entreprise, Ingénierie IT, Cybersécurité',
                    description: 'Co-Fondateur et pilier opérationnel de XyberClan. Onana dirige la stratégie commerciale de haut niveau, gère l\'infrastructure informatique et applique l\'ingénierie de cybersécurité pour protéger les systèmes et les données — combinant l\'analyse de données Python avec le leadership opérationnel pour élever chaque projet à un standard compétitif mondial.'
                },
                '6': {
                    name: 'William Chandler',
                    role: 'Designer de Contenu Visuel & Canva',
                    geography: 'Cameroun',
                    industry: 'Image de Marque & Design',
                    expertise: 'Design Canva Pro, Narration Visuelle, Branding Réseaux Sociaux',
                    description: 'Spécialiste du contenu visuel et designer de marque chez XyberClan. William produit des graphiques à fort impact et des actifs de marque qui communiquent clairement des idées complexes — maintenant une identité visuelle cohérente et premium sur toutes les plateformes et campagnes.'
                },
                '7': {
                    name: 'Theresa Tcheme',
                    role: 'Organisatrice d\'Événements & Gestionnaire Média',
                    geography: 'Cameroun',
                    industry: 'Communications & Médias',
                    expertise: 'Entrepreneuriat, Design UI/UX, Leadership Communautaire',
                    description: 'Étudiante en 2ème année d\'Informatique à l\'Université de Yaoundé I. Co-Fondatrice & CEO de Greenfarmers. Bénévole GDG Yaoundé et Organisatrice du programme Hult Prize OnCampus à l\'Université de Yaoundé I — impulsant l\'entrepreneuriat, la durabilité et la technologie sur le campus.'
                },
                '8': {
                    name: 'ADJIA MVOA NDJI GABRIEL MONFILS',
                    role: 'Développeur Fullstack & Ingénieur Systèmes',
                    geography: 'Cameroun',
                    industry: 'Génie Logiciel & Cybersécurité',
                    expertise: 'Développement Fullstack, C & Assembly, Administration Linux',
                    description: 'Étudiant en informatique à l\'Université de Yaoundé I et ingénieur multidisciplinaire chez XyberClan. Gabriel conçoit et construit des applications web fullstack, écrit du code bas niveau en C et Assembly, administre des systèmes Linux, développe des jeux avec Godot, mène des opérations de cybersécurité offensives et défensives, architecture des réseaux, orchestre des workflows IA via n8n et applique l\'analyse des marchés financiers — alliant rigueur académique et livraison d\'ingénierie concrète.'
                },
                '9': {
                    name: 'Lembou Pharel',
                    role: 'Ingénieur Cybersécurité, DevOps & IA',
                    geography: 'Cameroun',
                    industry: 'Cybersécurité & IA',
                    expertise: 'Tests d\'Intrusion, DevOps & CI/CD, Ingénierie Systèmes',
                    description: 'Ingénieur cybersécurité, praticien DevOps et architecte systèmes chez XyberClan. Lembou effectue des tests d\'intrusion, automatise et gère l\'infrastructure CI/CD, construit des applications web et mobiles sécurisées (Flutter), et applique l\'IA pour renforcer les systèmes — livrant des solutions intelligentes, résilientes et prêtes pour la production.'
                },
                '10': {
                    name: 'Wandji Tchaleu Yann Félix',
                    role: 'Ingénieur Réseau, Designer UI/UX & Développeur Python',
                    geography: 'Cameroun',
                    industry: 'Réseaux & Développement',
                    expertise: 'Réseau & CCNA, Développement Python, Design Graphique',
                    description: 'Ingénieur réseau et développeur Python chez XyberClan. Certifié CCNA, Yann Félix conçoit et maintient des infrastructures réseau robustes, développe des outils d\'automatisation et de données en Python, et contribue son expertise en design graphique — faisant le pont entre la profondeur technique et la communication visuelle claire.'
                }
            }
        },
        speakersPage: {
            metaTitle: 'Nos Intervenants | Experts Webinaires XyberClan',
            metaDesc: 'Découvrez notre sélection d\'intervenants experts partageant leurs connaissances en cybersécurité, IA, développement fullstack et innovation numérique.',
            label: 'Intervenants XyberClan',
            title: 'Nos',
            titleBold: 'Intervenants.',
            subtitle: 'Experts du secteur et leaders d\'opinion partageant des informations actionnables sur la cybersécurité, l\'IA, le développement et la transformation numérique.',
            connect: 'Connectez-vous avec',
            speakers: {
                '1': {
                    name: 'Vanessa Manessong',
                    role: 'Analyste de Données d\'Investigation & OSINT',
                    description: 'Analyste de données spécialisée dans l\'analyse des écosystèmes informationnels, la désinformation en ligne et les enquêtes OSINT. Fondatrice de Gehmit, une organisation engagée dans l\'orientation et la formation des jeunes aux métiers du numérique. Passionnée par la data, l\'IA et l\'impact social des technologies.'
                },
                '2': {
                    name: 'Cabrel Donfang',
                    role: 'Serial Event Organiser & Tech Evangelist',
                    description: 'Organisateur d\'événements en série, fournisseur de solutions et évangéliste technologique. Passionné par la construction de communautés, la connexion des innovateurs et l\'adoption de la technologie à travers l\'Afrique.'
                },
                '3': {
                    name: 'Tamkwa Kamga Brandon',
                    role: 'Développeur Fullstack IA & DevOps',
                    description: 'Fondateur et Mentor chez LesCrack. Développeur Fullstack AI et DevOps chez Gehmit. Passionné par la création de solutions alimentées par l\'IA évolutives et le mentorat de la prochaine génération de développeurs.'
                },
                '4': {
                    name: 'Ndjana Mengue Jerry',
                    role: 'Community Builder & Tech Leader',
                    description: 'Co-Fondateur & COO chez Hinkaku, Organisateur GDG Yaoundé, Leader AWS Student Builder Group. Dévoué à la construction de communautés tech florissantes et à l\'autonomisation des étudiants en cloud computing et leadership.'
                },
                '5': {
                    name: 'Theresa Tcheme',
                    role: 'Organisatrice d\'Événements & Médiatrice',
                    description: '2ème année en Informatique à l\'Université de Yaoundé I. Co-Fondatrice & CEO de Greenfarmers. Volontaire GDG Yaoundé et Organisatrice du programme Hult Prize OnCampus à l\'Université de Yaoundé I.'
                }
            }
        },
        portfolioPage: {
            title: 'Notre Portfolio',
            subtitle: 'Une vitrine des projets que nous avons construits, conçus et livrés avec passion.',
            filterLabel: 'Filtrer par',
            ctaBadge: 'Démarrer un projet',
            ctaHeading: 'Prêt à construire quelque chose d\'exceptionnel ?',
            ctaLink: 'Contactez-nous ↗',
            badge: 'Notre Travail',
            ctaTitle: 'Vous avez un projet en tête ?',
            ctaDesc: 'Laissez-nous donner vie à votre vision. Commencez votre projet dès aujourd\'hui.',
            ctaButton: 'Commencer Votre Projet',
            viewAll: 'Voir Tous les Projets',
            visitSite: 'Visiter le site',
            categories: {
                all: 'Tout',
                web: 'Développement Web',
                mobile: 'Applications Mobiles',
                design: 'Design & UI/UX',
                security: 'Cybersécurité'
            }
        },
        footer: {
            tagline: 'Construire des Rêves Numériques à Yaoundé',
            columns: {
                nav: {
                    title: 'NAVIGATION',
                    items: [
                        { label: 'À Propos', url: '/#about' },
                        { label: 'Services', url: '/#services' },
                        { label: 'Notre Équipe', url: '/team' },
                        { label: 'Nos Partenaires', url: '/partners' },
                        { label: 'Notre Parcours', url: '/journey' },
                        { label: 'Événements & Blog', url: '/events' },
                        { label: 'Portfolio', url: '/portfolio' }
                    ]
                },
                expertise: {
                    title: 'EXPERTISE',
                    items: [
                        { label: 'Cybersécurité', url: '/#services' },
                        { label: 'Dév Logiciel', url: '/#services' },
                        { label: 'Solutions Matériel', url: '/#services' },
                        { label: 'Stratégie Digitale', url: '/#services' }
                    ]
                },
                support: {
                    title: 'SUPPORT',
                    items: [
                        { label: 'Politique de Confidentialité', url: '/privacy' },
                        { label: 'Conditions d\'Utilisation', url: '/terms' },
                        { label: 'Contactez-nous', url: '/#contact' }
                    ]
                }
            },
            cta: {
                title: 'Prêt à lancer un projet ?',
                subtitle: "Construisons quelque chose d'exceptionnel ensemble.",
                emailLabel: 'ÉCRIVEZ-NOUS',
                email: 'xyberclandev@gmail.com',
                phoneLabel: 'APPELEZ-NOUS',
                phone: '+237 6 54 26 94 88 / +237 6 96 81 43 91'
            },
            copyright: 'XYBERCLAN — CONÇU AU CAMEROUN.',
            bottomLinks: {
                privacy: 'CONFIDENTIALITÉ',
                terms: 'CONDITIONS'
            },
            madeWith: 'Fait avec',
            madeBy: 'par XyberClan'
        },
        form: {
            step: 'Étape',
            of: 'de',
            backToHome: 'Retour à l\'Accueil',
            backToEdit: 'Retour pour Modifier',
            next: 'Suivant',
            previous: 'Précédent',
            submit: 'Envoyer la Demande',
            summaryTitle: 'Parfait ! Voici Votre Résumé',
            summaryDesc: 'Vérifiez vos informations et choisissez comment nous les envoyer',
            sendWhatsApp: 'Envoyer via WhatsApp',
            sendEmail: 'Envoyer via Email',
            chooseSend: 'Choisissez comment envoyer les détails de votre projet :',
            projectType: 'Type de Projet',
            projectName: 'Nom du Projet',
            description: 'Description',
            timeline: 'Délai',
            budget: 'Budget',
            contactInfo: 'Informations de Contact',
            name: 'Nom :',
            phone: 'Tél :',
            email: 'Email :',
            questions: {
                projectType: '🤔 De quel type de projet avez-vous besoin ?',
                projectName: '🤩 Quel est le nom de votre projet ou entreprise ?',
                description: '😃 Parlez-nous de votre projet',
                timeline: '🧐 Quel est votre délai ?',
                budget: '🤑 Quelle est votre fourchette de budget ?',
                contact: '👋 Comment pouvons-nous vous contacter ?'
            },
            placeholders: {
                projectName: 'ex: Ma Super Startup',
                description: 'Décrivez ce dont vous avez besoin, vos objectifs et vos exigences spécifiques...',
                contactName: 'Jean Dupont',
                contactPhone: '+237 6XX XX XX XX',
                contactEmail: 'jean@exemple.com'
            },
            options: {
                web: 'Développement Web',
                mobile: 'App Mobile',
                design: 'Design Graphique',
                cybersec: 'Cybersécurité',
                hardware: 'Matériel/Réseau',
                training: 'Formation Tech',
                asap: 'Dès que possible',
                weeks: '1-2 Semaines',
                month: '1 Mois',
                months: '2-3 Mois',
                flexible: 'Flexible',
                under100k: 'Moins de 100k XAF',
                range1: '100k - 500k XAF',
                range2: '500k - 1M XAF',
                over1m: '1M+ XAF',
                notSure: 'Pas Sûr Encore'
            },
            contactLabels: {
                name: 'Votre Nom',
                phone: 'Numéro de Téléphone',
                email: 'Adresse Email'
            },
            serviceQuestions: {
                web: [
                    {
                        id: 'webGoal',
                        question: '🌐 Quel est l\'objectif principal de votre site ?',
                        options: ['E-commerce / Boutique', 'Profil d\'Entreprise', 'Portfolio / Personnel', 'App Web Sur Mesure']
                    },
                    {
                        id: 'webPages',
                        question: '📄 Environ combien de pages avez-vous besoin ?',
                        options: ['1 Page (Landing Page)', '3-5 Pages', '6-10 Pages', '10+ Pages / Grand Portail']
                    },
                    {
                        id: 'webFeatures',
                        multi: true,
                        question: '⚙️ Quelles fonctionnalités sont essentielles ?',
                        options: ['Formulaire de Contact', 'Authentification Utilisateur', 'Paiements en Ligne', 'Blog / CMS', 'Optimisation SEO', 'Support Multilingue', 'Newsletter / Marketing Email', 'Tableau de Bord Analytics']
                    }
                ],
                mobile: [
                    {
                        id: 'mobilePlatform',
                        question: '📱 De quelle plateforme avez-vous besoin ?',
                        options: ['Android', 'iOS (iPhone)', 'Les deux / Cross-platform']
                    },
                    {
                        id: 'mobileType',
                        question: '💡 Quel type d\'application est-ce ?',
                        options: ['E-commerce / Boutique', 'Réseau Social', 'Outil de Productivité', 'Système de Gestion']
                    }
                ],
                design: [
                    {
                        id: 'designType',
                        multi: true,
                        question: '🎨 De quels services de design avez-vous besoin ?',
                        options: ['Logo & Branding', 'Design UI/UX', 'Graphismes Réseaux Sociaux', 'Identité Visuelle Complète', 'Cartes de Visite', 'Design de Flyers / Brochures', 'Modélisation 3D', 'Montage Vidéo']
                    },
                    {
                        id: 'designStyle',
                        multi: true,
                        question: '🖌️ Quel style préférez-vous ?',
                        options: ['Minimaliste & Épuré', 'Audacieux & Coloré', 'Corporatif & Pro', 'Artistique & Unique', 'Vintage / Rétro', 'Futuriste / Tech', 'Luxe / Élégant']
                    }
                ],
                cybersec: [
                    {
                        id: 'secType',
                        question: '🛡️ Quel type de service de sécurité ?',
                        options: ['Audit de Sécurité', 'Tests d\'Intrusion', 'Suppression de Malware', 'Protection Continue']
                    },
                    {
                        id: 'secTarget',
                        question: '🎯 Quelle est la cible principale ?',
                        options: ['Site / App Web', 'Réseau d\'Entreprise', 'Application Mobile', 'Base de données / Cloud']
                    }
                ],
                hardware: [
                    {
                        id: 'hwType',
                        question: '💻 Quel service matériel vous faut-il ?',
                        options: ['Réparation Ordinateur', 'Installation Réseau', 'Mise à niveau Matériel', 'Maintenance Informatique']
                    },
                    {
                        id: 'hwUrgency',
                        question: '⚡ Quel est le degré d\'urgence ?',
                        options: ['Immédiat / Urgence', 'Sous 24-48 Heures', 'Routine / Planifié']
                    }
                ],
                training: [
                    {
                        id: 'trainingSubject',
                        question: '🎓 Que souhaitez-vous apprendre ?',
                        options: ['Programmation Web', 'Cybersécurité', 'Design Graphique', 'Bureautique / Bases Info']
                    },
                    {
                        id: 'trainingLevel',
                        question: '📊 Quel est votre niveau actuel ?',
                        options: ['Débutant Total', 'Intermédiaire', 'Avancé / Professionnel']
                    }
                ]
            }
        },
        seo: {
            title: "XyberClan — Agence Digitale | Web, Design & Cybersécurité | Afrique & Monde",
            description: "XyberClan — Votre partenaire digital de confiance pour le Web, le Design et la Cybersécurité. Solutions professionnelles partout dans le monde à des tarifs compétitifs.",
            h1: "Votre Partenaire Digital de Confiance",
            h2_why: "Pourquoi choisir XyberClan ?",
            h2_services: "Nos Services Disponibles Partout dans le Monde",
            h2_standards: "Un Partenaire Digital 24/7",
            h3_web: "Développement Web Professionnel",
            h3_design: "Design Graphique & UI/UX",
            h3_cyber: "Cybersécurité & Protection",
            h3_mobile: "Applications Mobiles",
            paragraph: "XyberClan est votre partenaire digital de confiance basé à Yaoundé, Cameroun, accompagnant des clients en France, Belgique, Canada, Suisse, Côte d'Ivoire, Sénégal, Nigéria, Ghana et partout dans le monde. Nous proposons le développement de sites web professionnels, la création d'applications mobiles, le design graphique, l'UI/UX design et la cybersécurité à des tarifs compétitifs. Notre équipe d'experts combine excellence technique et innovation créative pour livrer des solutions digitales de qualité mondiale adaptées à vos besoins.",
            h2_digital: "Excellence",
            h2_excellence: "digitale."
        },
        pricing: {
            title: "Tarification Simple et Transparente",
            subtitle: "Choisissez un plan qui répond à vos besoins. Tous les plans incluent notre garantie de qualité.",
            popularBadge: 'Le Plus Populaire',
            plans: [
                {
                    name: "Starter",
                    description: "Parfait pour les petits projets et pour commencer",
                    price: "50K",
                    currency: "XAF",
                    features: [
                        "Landing page simple (1-3 pages)",
                        "Design responsive mobile",
                        "Formulaire de contact",
                        "Configuration SEO de base",
                        "Livraison en 1 semaine",
                        "7 jours de support après livraison"
                    ],
                    cta: "Commencer Petit"
                },
                {
                    name: "Professionnel",
                    description: "Le plus populaire pour les entreprises en croissance",
                    price: "200K",
                    currency: "XAF",
                    features: [
                        "Site web complet (5-10 pages)",
                        "Design responsive premium",
                        "Formulaires de contact et réservation",
                        "Galerie photo & portfolio",
                        "Intégration réseaux sociaux",
                        "Optimisation SEO avancée",
                        "Livraison en 2 semaines",
                        "30 jours de support"
                    ],
                    cta: "Devenir Pro"
                },
                {
                    name: "Entreprise",
                    description: "Solutions sur mesure pour les grands projets",
                    price: "500K+",
                    currency: "XAF",
                    features: [
                        "Application web complète",
                        "Capacités e-commerce",
                        "Système d'authentification utilisateur",
                        "Tableau de bord admin",
                        "Intégration de paiement",
                        "Fonctionnalités personnalisées",
                        "Équipe dédiée",
                        "Support & maintenance prioritaires"
                    ],
                    cta: "Nous Contacter"
                }
            ],
            note: "Tous les prix sont des points de départ. Le devis final dépend des exigences spécifiques."
        },
        stats: {
            badge: 'Impact',
            title: 'Des chiffres qui racontent l\'histoire.',
            subtitle: 'Des résultats réels, des clients réels, une croissance réelle.'
        },
        team_minimal: {
            badge: "Le XyberClan",
            title: "Rencontrez Notre Équipe d'Experts",
            subtitle: "Un collectif d'ingénieurs logiciels, de designers et de stratèges dédiés à fournir une qualité de niveau entreprise.",
            items: [
                {
                    title: "Excellence en Ingénierie",
                    desc: "Nos développeurs ne sont pas seulement des codeurs ; ce sont des ingénieurs. Nous construisons pour la performance, la sécurité et la longévité."
                },
                {
                    title: "Esprit Design-First",
                    desc: "Nous croyons en des interfaces intuitives et belles. Chaque pixel a une utilité dans nos designs."
                },
                {
                    title: "Croissance Stratégique",
                    desc: "Aider les startups et les entreprises à étendre leur empreinte numérique avec des stratégies et des outils basés sur les données."
                }
            ]
        },
        features: {
            badge: 'Services',
            title: 'Ce que nous construisons pour vous.',
            subtitle: 'Quatre disciplines principales. Une équipe unifiée. Des possibilités infinies.',
            items: [
                { title: 'Développement Web & App', description: 'Des applications web performantes et évolutives construites avec des frameworks modernes. Code propre, architecture propre.', tag: 'Web & Apps' },
                { title: 'Cybersécurité', description: 'Audits de sécurité de niveau entreprise, tests d\'intrusion et durcissement. Vos données, défendues.', tag: 'Sécurité' },
                { title: 'Développement Mobile', description: 'Des expériences mobiles multiplateformes qui semblent natives sur iOS et Android.', tag: 'Mobile' },
                { title: 'Design UI/UX', description: 'Des interfaces qui convertissent. Parfait au pixel près, axé sur l\'accessibilité et centré sur l\'humain.', tag: 'Design' }
            ]
        },
        faq: {
            badge: "Des Questions ?",
            title: "Foire Aux Questions",
            subtitle: "Tout ce que vous devez savoir sur nos services",
            ctaText: "Encore des questions ? Nous sommes là pour vous aider.",
            ctaButton: "Discutez avec nous",
            items: [
                {
                    question: "Combien coûte un site web ?",
                    answer: "Nos sites web commencent à partir de 50 000 XAF pour les landing pages de base. Les sites web d'entreprise avec plusieurs pages, formulaires de contact et galeries varient généralement entre 150 000 et 500 000 XAF. Les sites e-commerce et les applications web font l'objet d'un devis personnalisé en fonction des fonctionnalités nécessaires."
                },
                {
                    question: "Combien de temps faut-il pour créer un site web ?",
                    answer: "Une simple landing page peut être réalisée en 3 à 5 jours. Les sites web d'entreprise standard prennent 1 à 2 semaines. Les projets plus complexes comme les boutiques e-commerce ou les applications web prennent généralement 3 à 6 semaines selon les fonctionnalités et les révisions."
                },
                {
                    question: "Proposez-vous le développement d'applications mobiles ?",
                    answer: "Oui ! Nous construisons des applications mobiles pour Android et iOS en utilisant des technologies modernes comme React Native et Flutter. Cela nous permet de créer une application qui fonctionne sur les deux plateformes, vous faisant gagner du temps et de l'argent."
                },
                {
                    question: "Quels modes de paiement acceptez-vous ?",
                    answer: "Nous acceptons Mobile Money (MTN, Orange), les virements bancaires et les paiements en espèces. Nous demandons généralement 50 % d'acompte pour commencer le projet, les 50 % restants étant dus à l'achèvement."
                },
                {
                    question: "Fournissez-vous un support continu ?",
                    answer: "Absolument ! Nous proposons des forfaits de maintenance à partir de 15 000 XAF/mois qui incluent l'hébergement, les mises à jour de sécurité, les sauvegardes et les modifications mineures de contenu. Nous sommes toujours là pour vous aider même après la fin de votre projet."
                },
                {
                    question: "Pouvez-vous aider pour le branding et le design ?",
                    answer: "Oui, nous offrons des services de branding complets incluant la création de logos, cartes de visite, graphismes pour réseaux sociaux, flyers et packages d'identité visuelle complète. Nos designers créent des designs modernes et professionnels qui font ressortir votre entreprise."
                },
                {
                    question: "Dois-je fournir le contenu de mon site web ?",
                    answer: "Bien que nous puissions travailler avec le contenu que vous fournissez, nous proposons également des services de rédaction de contenu. Nous pouvons vous aider à rédiger des textes convaincants pour votre site web et à trouver des images professionnelles si nécessaire."
                },
                {
                    question: "Que se passe-t-il si je ne suis pas satisfait du design ?",
                    answer: "Nous travaillons en étroite collaboration avec vous tout au long du processus de conception et incluons des cycles de révision dans tous nos forfaits. Nous ne nous arrêterons pas tant que vous ne serez pas 100 % satisfait du résultat. Votre satisfaction est notre priorité."
                }
            ]
        },
        whoWeAre: {
            badge: 'Qui Sommes-Nous',
            title1: 'Excellence',
            title2: 'digitale.',
            subtitle: 'Ingénieurs formés à l\'université, livrant des solutions de niveau entreprise à la vitesse d\'une startup. Basés au Cameroun, au service du monde.',
            card1Title: 'Innovation Rapide',
            card1Desc: 'Du concept au déploiement en quelques jours, pas en mois. Nous concevons la rapidité sans sacrifier la qualité.',
            card2Title: 'Architecture Évolutive',
            card2Desc: 'Des systèmes conçus pour gérer des millions d\'utilisateurs dès le premier jour, bâtis pour le long terme.',
            card3Title: 'Génération de Revenus',
            card3Desc: 'Chaque ligne de code et chaque pixel est intentionnel — conçu pour convertir, fidéliser et développer.'
        },
        exitPopup: {
            title: 'Attendez ! Avant de partir...',
            subtitle: 'Une offre spéciale rien que pour vous',
            badge: 'Offre à Durée Limitée',
            offerTitle: 'Obtenez 10% DE RÉDUCTION sur Votre Premier Projet !',
            offerBody: 'Lancez votre projet avec nous dès aujourd\'hui et obtenez une réduction exclusive de 10%. Mentionnez simplement cette offre lorsque vous nous contactez !',
            ctaButton: 'Réclamez Votre Réduction',
            dismiss: 'Non merci, peut-être plus tard'
        },
        get_started: {
            badge: 'Intégrations',
            title: 'Commencez en quelques étapes simples.',
            subtitle: 'Que vous soyez une petite entreprise ou une grande organisation, notre processus améliore la productivité et simplifie votre flux de travail.',
            labels: {
                design: 'Design',
                code: 'Code',
                comm: 'Comm',
                deploy: 'Déployer',
                contact: 'Contact',
                support: 'Support'
            }
        },
        newsletter: {
            badge: 'Newsletter',
            title: 'Restez informé.',
            subtitle: 'Recevez des astuces tech, des mises à jour et des offres exclusives directement dans votre boîte mail.',
            note: 'Pas de spam. Désabonnement à tout moment.'
        },
        cta: {
            title: "Prêt à",
            titleLine2: "commencer ?",
            subtitle: "Pas de démos, pas de longs appels. Dites-nous ce dont vous avez besoin — nous le construirons.",
            primaryButton: "Lancer votre projet",
            secondaryButton: "Ou contactez-nous →"
        },
        heroArc: {
            cards: [
                { title: 'XyberShield App' },
                { title: 'NB Dance' },
                { title: 'Vanguard' },
                { title: 'Marketplace' },
                { title: 'Créatif' }
            ]
        },
        testimonials: {
            badge: 'Témoignages',
            title: 'Ce que disent nos clients.',
            subtitle: 'Des mots réels de clients qui ont livré avec nous.',
            list: [
                { quote: 'Du concept au produit lancé en un temps record. XyberClan a livré exactement ce dont nous avions besoin.', author: 'Paul Smith', role: 'Testeur Logiciel', company: 'Monaco' },
                { quote: 'Leur attention aux détails UX est inégalée. Notre taux de conversion a bondi de 40 % après la refonte.', author: 'Tim Williams', role: 'Chef d\'Entreprise', company: 'Proline' },
                { quote: 'L\'audit de sécurité qu\'ils ont effectué a trouvé des vulnérabilités critiques que nous ignorions. Travail exceptionnel.', author: 'Katie Adams', role: 'Entrepreneuse', company: 'Delaware' },
                { quote: 'De la conception au déploiement en deux semaines. Rapide, réactif et parfaitement aligné sur la marque. Je recommande vivement.', author: 'Alex Schiller', role: 'Ingénieur Senior', company: 'Luminous' }
            ]
        },
        whatsapp: {
            tooltip: 'Parlez avec nous ! 👋',
            contacts: [
                { label: 'Contact 1', number: '+237 654 269 488' },
                { label: 'Contact 2', number: '+237 696 814 391' }
            ]
        },
        careerPopup: {
            heading: "Nous Recrutons !",
            badge: 'Poste Community Manager',
            tag: 'Rejoignez l\'Équipe XyberClan',
            title: 'Façonnez Notre Communauté',
            description: 'Nous recherchons un Community Manager passionné pour développer notre communauté numérique. Aidez-nous à connecter, engager et bâtir des relations durables avec notre public.',
            cta: 'Postuler',
            dismiss: 'Pas maintenant'
        },
        themeSuggestion: {
            title: 'Mieux en Mode Sombre ?',
            description: 'Basculez pour l\'expérience néon complète.',
            dismiss: 'Non Merci',
            cta: 'Activer'
        }
    }
};
